import { RedoClient } from "@redotech/redo-api-client";
import { createRoot } from "react-dom/client";
import {
  getAutocheck,
  ShopifyExtensionClient,
} from "../../client/shopify-extension-client";
import { log } from "../../monitoring/log";
import { DeliveryEstimateInitializer } from "../../redo-storefront/delivery-estimate/delivery-estimate-initializer";
import { RedoDeliveryEstimateContainerElement } from "../../redo-storefront/delivery-estimate/element";
import {
  PRODUCT_PAGE_DELIVERY_ESTIMATE_CONTAINER_ID,
  STYLE_DISPLAY_UNSET,
} from "../../redo-storefront/delivery-estimate/use-render-pdps";
import { RedoStorefrontContainer } from "../../redo-storefront/redo-storefront-container";

void import("./styles.css");

// This should always match the id of the div in the delivery-estimate.liquid file
export const APP_BLOCK_DELIVERY_ESTIMATE_CONTAINER_ID =
  "redo-delivery-estimate-target";

async function initialize() {
  log("Initializing Delivery Estimate app block");

  const containerFromLiquidFile = document.getElementById(
    APP_BLOCK_DELIVERY_ESTIMATE_CONTAINER_ID,
  );

  if (!containerFromLiquidFile) {
    log("Delivery estimate container not found");
    return;
  }

  // Shopify applies display: none to empty divs
  containerFromLiquidFile.style.display = "unset";

  try {
    const redoApiUrl =
      globalThis.redoStorefront?.env?.REDO_API_URL ?? process.env.REDO_API_URL!;
    if (!redoApiUrl) {
      log("REDO_API_URL is not set");
      return;
    }

    const redoClient = new RedoClient(redoApiUrl);
    const widgetClient = new ShopifyExtensionClient(
      redoClient,
      globalThis.redoWidgetId,
      globalThis.redoStorefront?.storeUrl ??
        globalThis.Shopify?.shop ??
        globalThis.Shopify?.Checkout?.apiHost,
    );

    const customerId =
      (globalThis as any).ShopifyAnalytics?.meta.page.customerId || null;

    const autocheck = await getAutocheck(widgetClient, { customerId });

    if (
      !autocheck.conversion.enabled ||
      !autocheck.conversion.deliveryEstimate.enabled
    ) {
      log("Delivery estimate not enabled for this store");
      return;
    }

    const root = createRoot(containerFromLiquidFile);

    // Register the custom element if not already registered
    RedoDeliveryEstimateContainerElement.register();

    const pdpElement = document.createElement(
      RedoDeliveryEstimateContainerElement.TAG,
    ) as RedoDeliveryEstimateContainerElement;
    pdpElement.id = PRODUCT_PAGE_DELIVERY_ESTIMATE_CONTAINER_ID;
    pdpElement.style.display = STYLE_DISPLAY_UNSET;
    containerFromLiquidFile.append(pdpElement);

    root.render(
      <RedoStorefrontContainer container={containerFromLiquidFile}>
        <DeliveryEstimateInitializer
          appBlockContainer={pdpElement}
          deliveryEstimateSettings={autocheck.conversion.deliveryEstimate}
        />
      </RedoStorefrontContainer>,
    );

    log("Delivery estimate app block initialized successfully");
  } catch (error) {
    log("Error initializing delivery estimate app block:", error);
  }
}

void initialize();
